export class TemplateLoader {
    // public properties
    public templateIsLoaded: boolean;

    // constructors
    constructor(public templateFileName: string) {

    }

    // public Methods

    // render method
    // takes the content of the specified template and copies
    // into the specified control.  Template may be loaded async.
    // returns a jQuery promise object that can be used to run code
    // when the template is done loading.
    public render(templateName: string, container?: JQuery): JQuery.Promise<any, any, any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        let onLoad: () => void;

        if (container != null) {
            onLoad = () => {
                container.html($("#" + templateName).html());
                deferred.resolve();
            };
        } else {
            // no container, so don't render, just load
            onLoad = () => {
                deferred.resolve();
            };
        }

        this.loadTemplate(templateName, onLoad);

        return deferred.promise();
    }

    // private Methods

    // loadTemplate method
    // if the template has not been loaded, then make an AJAX
    // call to get the template.
    private loadTemplate(templateName: string, onSuccess: () => void): void {
        if (this.templateIsLoaded === null) {
            // first time checking, see if template is loaded
            this.templateIsLoaded = this.isTemplateLoaded(templateName);
        }

        if (this.templateIsLoaded) {
            // template already loaded
            onSuccess();
        } else {
            // load the template from the file
            const me: TemplateLoader = this;
            const date: Date = new Date();
            const url: string = "/templates/" + this.templateFileName + ".html?t=" + date.getTime();

            $.get(
                url,
                (data: any) => {
                    $("body").append(data);
                    me.templateIsLoaded = true;
                    onSuccess();
                },
            );
        }
    }

    // isTemplateLoaded
    // checks if the template file has been loaded by looking in the DOM
    private isTemplateLoaded(templateName: string): boolean {
        return $("#" + templateName).length > 0;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/templateLoader.ts